import React, {useState} from 'react';

import {Button, Form, Modal} from '@components';
import mappings from '@mappings';
import utils from '@utils';

import * as hooks from './hooks';
import {Props} from './types';

import './index.scss';

const Answer: React.FC<Props> = props => {
  const [isModal, setIsModal] = useState(false);
  hooks.useMount(props, setIsModal);

  return (
    <div className="a__notification-answer">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        回答状況確認
      </div>
      <div className="b__answer-field">
        <div className="w__label-field">
          <Form.Label text="安否確認送信日時" />

          <div className="w__date">
            {props.notifications.detail.answer && (
              <span>
                {utils.date.format(
                  props.notifications.detail.sentDatetime ||
                    props.notifications.detail.answer.sentDatetime,
                  'YYYY/MM/DD HH:mm:ss'
                )}
              </span>
            )}
          </div>
        </div>
        <div className="w__label-field">
          <Form.Label text="最終回答日時" />
          <div className="w__date">
            {props.notifications.detail.answer && (
              <span>
                {utils.date.format(
                  props.notifications.detail.answer.replyDatetime,
                  'YYYY/MM/DD HH:mm:ss'
                )}
              </span>
            )}
          </div>
        </div>
        <div className="w__label-field name">
          <div className="w__name">
            <Form.Label text="姓" />
            <div className="answer-content">
              {props.notifications.detail.answer && (
                <span>{props.notifications.detail.answer.lastName}</span>
              )}
            </div>
          </div>
          <div className="w__name left">
            <Form.Label text="名" />
            <div className="answer-content">
              {props.notifications.detail.answer && (
                <span>{props.notifications.detail.answer.firstName}</span>
              )}
            </div>
          </div>
        </div>

        <div className="w__label-field">
          <Form.Label text="怪我の状態" />
          <div className="answer-content input">
            {props.notifications.detail.answer && (
              <span>
                {utils.mappings.getLabel(
                  mappings.injuries,
                  props.notifications.detail.answer.injuryStatus
                )}
              </span>
            )}
          </div>
        </div>
        <div className="w__label-field">
          <Form.Label text="連絡事項" />
          <div className="answer-content lg">
            {props.notifications.detail.answer && (
              <span>{props.notifications.detail.answer.message}</span>
            )}
          </div>
        </div>
        <div className="w__button">
          <Button.Normal
            text="ユーザーの詳細を確認する"
            color="green"
            className="b__edit"
            onClick={() => {
              props.history.push(
                `/users/detail/${props.notifications.detail.answer.userId}`
              );
            }}
          />
        </div>
      </div>
      <Modal.Normal
        hideCloseIcon
        hiddenCancelButton
        isAutoClose={false}
        isModal={isModal}
        handleCloseModal={setIsModal}
        size="xs"
        title="回答状況が存在しません"
        cancelText="前のページに戻る"
        message="存在しない回答状況です。
            ボタンをクリックして、前のページに戻ってください。"
      >
        <Button.Normal
          text="前のページに戻る"
          onClick={() => props.history.goBack()}
          color="yellow"
          className="b__go-back"
        />
      </Modal.Normal>
    </div>
  );
};

export default Answer;
